<div class="wrapper flex column">
  <app-header [heading]="'CASES.HEADER.TITLE' | translate"></app-header>
  <main class="cases-container grow1">
    @if (showCasesTable()) {
      <payee-cases
        [getCasesPath]="getCasesPath"
        [getDebtorsPath]="getDebtorsPath"
        [showClientColumn]="showClientColumn()"
        [showPartnerColumn]="false"
        [showExport]="true"
        [searchClients]="searchClients"
        [resolveClient]="resolveClient"
      ></payee-cases>
    }
  </main>
</div>
